/**
 *
 * Styles for TeaserOverlay
 *
 */

import styled from "styled-components";
import { Headline } from "root/libs/ui-components/src";
import { DhlText } from "@dhl-official/react-library";
import { breakpoints } from "root/libs/ui-styleguide/src";

export const TeaserOverlayWrapper = styled.div`
  background: linear-gradient(to left, #ffe800, var(--dui-color-yellow-500));
  position: fixed;
  transform: translateY(100%);
  bottom: 0;
  left: 0;
  width: 100%;
  transition: transform 0.2s ease-out;
  z-index: 999;

  &.active {
    transform: translateY(0);
  }
`;

export const ContentWrapper = styled.div`
  padding: var(--gaq-size-space-35px);
  margin: 0 auto;

  @media screen and (min-width: ${breakpoints.tablet}) {
    padding: var(--gaq-size-space-34px) var(--dui-size-space-10x);
    display: flex;
  }
`;

export const ContentWrapperCopy = styled.div`
  margin-bottom: var(--dui-size-space-10x);

  @media screen and (min-width: ${breakpoints.tablet}) {
    margin-bottom: 0;
    padding-right: var(--gaq-size-space-30px);
    width: 100%;
  }
`;

export const ContentWrapperButton = styled.div`
  text-align: center;

  @media screen and (min-width: ${breakpoints.tablet}) {
    text-align: right;
  }

  @media screen and (min-width: ${breakpoints.tablet}) and (max-width: 1070px) {
    padding-right: var(--dui-size-space-20x);
  }

  button {
    width: auto;
  }
`;

export const StyledIcon = styled.div`
  position: absolute;
  right: 10px;
  top: 10px;
`;

export const StyledHeadline = styled(Headline)`
  text-align: center;
  padding: 0 var(--dui-size-space-20x);
  margin-bottom: 0;

  @media screen and (min-width: ${breakpoints.tablet}) {
    text-align: left;
    padding: 0;
  }
`;

export const StyledText = styled(DhlText)`
  & > *:is(p, span) {
    text-align: center;
    margin-bottom: 0;

    @media screen and (min-width: ${breakpoints.tablet}) {
      text-align: left;
    }
  }
`;
